import React from 'react'
import { HeadingLG, HeadingMD, HeadingSM, ParagraphMD } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const DryBarPlusOffer: React.FC = () => {
  const { t } = useTranslate('guild')
  return (
    <div className="relative">
      <HeadingLG weight="bold" color="white" className="text-center uppercase lg:pt-16">
        <Translate i18nKey="exclusive" t={t}>
          Exclusive
        </Translate>
      </HeadingLG>
      <HeadingMD weight="bold" color="white" className="text-center uppercase">
        <Translate i18nKey="angelGuildOffer" t={t}>
          Angel Guild Offer
        </Translate>
      </HeadingMD>
      <div className="mx-auto mt-3 w-fit bg-[#FFD800] px-3 py-1">
        <HeadingSM weight="bold">
          <Translate i18nKey="justForYou" t={t}>
            JUST FOR YOU
          </Translate>
        </HeadingSM>
      </div>
      <div>
        <ParagraphMD weight="bold" color="white" className="pt-8 text-center">
          <Translate i18nKey="dryBarPlusOfferv1" t={t}>
            Join today and lock in 50% off for LIFE &mdash; that&apos;s just $6/month forever for our Basic Membership.
          </Translate>
        </ParagraphMD>
      </div>
    </div>
  )
}
